import React, {useState} from 'react';
import {useOpenApiFpRequest} from '../../Http/useOpenApiRequest';
import {UserApi, UserRole} from '../../scaffold';
import CommonApiErrorHandler from '../../utils/HttpInstance';
import {useBoolean, useInput} from 'react-hanger';
import {Button, Form, Input, Modal, Radio, Select, Skeleton} from 'antd';

export default function UpdateStudentInfoBtn(props: {userId: number; refresh: () => any}) {
  const findHook = useOpenApiFpRequest(UserApi, UserApi.prototype.userFindGet);
  const listUser = useOpenApiFpRequest(UserApi, UserApi.prototype.userListGet);
  const saveHook = useOpenApiFpRequest(UserApi, UserApi.prototype.userUpdateStudentInfoPost);
  const name = useInput('');
  const username = useInput('');
  const telephone = useInput('');
  const email = useInput('');
  const school = useInput('');
  const grade = useInput('');
  const [teacherId, setTeacherId] = useState<number>();
  const thesisStartReport = useInput('');
  const thesisMiddleReport = useInput('');
  const thesisReady = useInput('');
  const thesisOk = useInput('');
  const GPA = useInput('');
  const isOpen = useBoolean(false);
  function find() {
    findHook
      .request({id: props.userId})
      .then(res => {
        name.setValue(res.name || '');
        username.setValue(res.username || '');
        telephone.setValue(res.telephone || '');
        email.setValue(res.email || '');
        school.setValue(res.school || '');
        grade.setValue(res.grade || '');
        setTeacherId(res.teacherId || 0);
        thesisStartReport.setValue(res.thesisStartReport || '');
        thesisMiddleReport.setValue(res.thesisMiddleReport || '');
        thesisReady.setValue(res.thesisReady || '');
        thesisOk.setValue(res.thesisOk || '');
        GPA.setValue(res.gpa || '');
      })
      .catch(CommonApiErrorHandler);
    listUser
      .request({})
      .then()
      .catch();
  }
  return (
    <div>
      <a
        onClick={() => {
          isOpen.setTrue();
          find();
        }}>
        修改学生信息
      </a>
      <Modal
        visible={isOpen.value}
        onCancel={isOpen.setFalse}
        title={'修改学生信息'}
        okButtonProps={{loading: saveHook.loading}}
        onOk={() => {
          saveHook
            .request({
              studentUpdateInfoModel: {
                id: props.userId,
                name: name.value,
                username: username.value,
                telephone: telephone.value,
                email: email.value,
                school: school.value,
                grade: grade.value,
                teacherId: teacherId as number,
                thesisStartReport: thesisStartReport.value,
                thesisMiddleReport: thesisMiddleReport.value,
                thesisReady: thesisReady.value,
                thesisOk: thesisOk.value,
                gpa: GPA.value,
              },
            })
            .then(() => {
              isOpen.setFalse();
              props.refresh();
            })
            .catch(CommonApiErrorHandler);
        }}>
        <Skeleton loading={findHook.loading}>
          <Form>
            <Form.Item label={'姓名'}>
              <Input {...name.eventBind} />
            </Form.Item>
            <Form.Item label={'学号（用户名）'}>
              <Input {...username.eventBind} />
            </Form.Item>
            <Form.Item label={'联系方式'}>
              <Input {...telephone.eventBind} />
            </Form.Item>
            <Form.Item label={'邮箱'}>
              <Input {...email.eventBind} />
            </Form.Item>
            <Form.Item label={'所属专业'}>
              <Input {...school.eventBind} />
            </Form.Item>
            <Form.Item label={'入学年份'}>
              <Input {...grade.eventBind} />
            </Form.Item>
            <Form.Item label={'导师'}>
              <Select
                value={teacherId}
                onChange={setTeacherId}
                style={{width: 200}}
                showSearch
                filterOption={(input, option) => (option?.title ?? '').includes(input.toLowerCase())}>
                {listUser?.data
                  ?.filter(i => i.role === UserRole.教师)
                  .map(u => (
                    <Select.Option title={u.name ?? ''} label={u.name} key={u.id} value={u.id as number}>
                      {u.name}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
            <Form.Item label={'论文开题报告'}>
              <Input {...thesisStartReport.eventBind} />
            </Form.Item>
            <Form.Item label={'论文中期检查'}>
              <Input {...thesisMiddleReport.eventBind} />
            </Form.Item>
            <Form.Item label={'是否可论文送审'}>
              <Input {...thesisReady.eventBind} />
            </Form.Item>
            <Form.Item label={'过程管理是否合格'}>
              <Input {...thesisOk.eventBind} />
            </Form.Item>
            <Form.Item label={'GPA(当前/已修/要求)'}>
              <Input {...GPA.eventBind} />
            </Form.Item>
          </Form>
        </Skeleton>
      </Modal>
    </div>
  );
}
